<template>
    <validation-provider
        v-slot="{ errors }"
        name="Ponto de Referência"
        :rules="rules"
    >
        <b-form-group label="Ponto de Referência" label-for="ponto-referencia-input">
            <b-form-input
                id="ponto-referencia-input"
                v-model="selected"
                placeholder="Informe o ponto de referência"
                :disabled="desabilitarCamposDadosCriacao"
            />
            <small v-if="errors.length" class="text-danger d-block">{{ errors[0] }}</small>
        </b-form-group>
    </validation-provider>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate'

export default {
    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
        desabilitarCamposDadosCriacao: {
          type: Boolean,
          required: false,
          default: false,
        },
    },
    components: {
        BFormGroup, BFormInput, ValidationProvider
    },
    data() {
        return {
            selected: null,
            rules: 'min:3|max:255',
        }
    },
    mounted() {
        this.selected = this.value
    },
    watch: {
        selected: function (val) {
            this.$emit('updated', val);
        }
    }
}
</script>